// Components
import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

// Icons
import TG from "@/assets/icons/motivators/tempGuaranteed/TG.svg";

const TemporaryGuaranteedView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Temporary Guaranteed",
	headerIcon: TG,
	motivatorType: "temporaryGuaranteed",
});

const SalesTemporaryGuaranteedView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Temporary Guaranteed",
	headerIcon: TG,
	motivatorType: "salesTemporaryGuaranteed",
});

export { TemporaryGuaranteedView, SalesTemporaryGuaranteedView };
